<template>
  <section class="sumo-bg-dark py-5">
    <div class="container">
      <div class="text-center mx-auto signup-content">
        <h4 class="sumo-text-brand mb-3 h2">
          Sign Up
        </h4>
        <p class="mb-3">
          All our deals are time-sensitive! Make sure you don't miss any
          of our awesome limited-time offers.
        </p>
        <form
          id="signup_email_form"
          class="md-form form-inline justify-content-center"
          method="post"
          action="/accounts/signup/email/"
        >
          <input
            type="hidden"
            name="csrfmiddlewaretoken"
            :value="csrftoken"
          >
          <label for="email" class="sr-only">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            placeholder="Enter Your Email Here..."
            class="email-signup form-control rounded mr-0"
            required
          >
          <button
            class="btn btn-primary mt-3 mt-lg-0 btn-single-submit rounded submit-signup"
            type="submit"
          >
            Never miss a deal
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      csrftoken: '',
    };
  },
  mounted() {
    this.csrftoken = this.$cookies.get('csrftoken');
  },
};
</script>

<style scoped>
/* TODO: Cleanup once Dorado styles are incorporated */
.signup-content {
  max-width: 530px;
}

.email-signup {
  padding-left: calc(1rem - 1px) !important;
  border-color: transparent !important;
  font-size: 1rem !important;
  transition: none !important;
  width: 100% !important;
}

.submit-signup {
  background-color: #ffbc00;
  border-color: #ffbc00;
  color: #272727;
}

.submit-signup:hover {
  background-color: #ffcb33;
  border-color: #ffbc00;
  color: #272727;
}

@media screen and (min-width: 992px) {
  .email-signup {
    border-bottom-right-radius: 0 !important;
    border-top-right-radius: 0 !important;
    width: auto !important;
  }

  .submit-signup {
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important;
    margin-left: -1px;
    height: 3rem;
  }
}
</style>
